import useCounter from './use-counter.js';

function useCountDown(_ref) {
  var _ref$time = _ref.time,
      time = _ref$time === void 0 ? 0 : _ref$time,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? '' : _ref$format,
      onFinish = _ref.onFinish,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1000 : _ref$duration;
  return useCounter({
    time: time,
    format: format,
    onFinish: onFinish,
    duration: duration,
    countDown: true
  });
}

export { useCountDown as default };
//# sourceMappingURL=use-count-down.js.map
